<div *ngIf="!isSimple" class="widget-display-container" style="height:550px; padding:20px; margin:auto; width:340px; background-color: #2A304B; cursor:grab" cdkDrag>
    <element-render-iframe  [element]="element"></element-render-iframe>
</div>

<div *ngIf="isSimple" class="calculator-drag-boundary" #dragBoundary>
    <div class="calculator-position" cdkDrag #calculatorDrag="cdkDrag"
         [cdkDragBoundary]="dragBoundary" [cdkDragFreeDragPosition]="dragPosition"
         (cdkDragEnded)="scheduleBoundsUpdate()">
    <div class="calc-container" 
         #container tabindex="0" 
         (focus)="onCalculatorFocus()" 
         (focusout)="onCalculatorFocusOut()"
    >
        <span class="calc-edge-handle calc-edge-left" cdkDragHandle aria-hidden="true"></span>
        <span class="calc-edge-handle calc-edge-right" cdkDragHandle aria-hidden="true"></span>
        <span class="calc-edge-handle calc-edge-bottom" cdkDragHandle aria-hidden="true"></span>
        <div class="calc-display" cdkDragHandle>
            <span
                style="position: absolute; top: 1px; left: 50%; transform: translateX(-50%); color: rgba(255, 255, 255, 0.3); cursor: grab; outline: none; line-height: 1;">
                <i class="fas fa-grip-horizontal" aria-hidden="true" style="font-size: 0.8em;"></i>
            </span>
        <div [ngStyle]="{'font-size.em':getFontDisplayScale()}">
            {{getScreenDisplay()}}
        </div>
    </div>
    <div class="button-container">
        <div class="button-container-main">
            <div class="button-container-main-top">
            <span
                    *ngFor="let btn of functionButtons"
                    (click)="pressFunction(btn.func)"
                    [class.is-2w]="btn.isDoubleWidth"
                    [class.is-3w]="btn.isTripleWidth"
            >{{btn.caption}}</span>
            </div>
            <div  class="button-container-main-bottom">
            <span
                    *ngFor="let btn of numberButtons"
                    (click)="pressNumber(btn.num)"
                    [class.is-2w]="btn.isDoubleWidth"
                    [class.is-3w]="btn.isTripleWidth"
            >{{btn.caption || btn.num}}</span>
            </div>
        </div>
        <div class="button-container-side">
            <button
            *ngFor="let btn of operatorButtons"  
            (click)="pressOperator(btn.operator)"
            [class.is-2w]="btn.isDoubleWidth"
            [class.is-3w]="btn.isTripleWidth"
            tabindex="-1"
            >{{btn.caption}}</button>
        </div>
    </div>
    <input id="null-focus" style="display:none"/>
</div>
    </div>
</div>
